import { Box, Flex, Text, Tooltip } from '@chakra-ui/react';
import {
  FileCodeIcon,
  GitMergeIcon,
  HourGlassIcon,
  LinkBroken,
  StopWatchIcon,
} from '@devd-client/devd/components';
import { Row } from '@tanstack/react-table';
import { Fragment } from 'react';
import { MdArrowRight } from 'react-icons/md';

// Below is what displays the breakdown row.
export const ExpandableContent = ({ row }: { row: Row<any> }) => {
  return (
    <Box p={2}>
      <Flex align="center">
        {row.original?.breakdowns?.map((item: any, index: number) => {
          const negativePattern = /-\d+/;
          return (
            <Fragment key={index}>
              <Flex align="center" mr={2}>
                <Tooltip
                  hasArrow
                  label={
                    item.value
                      ? item.title === 'Waiting Time'
                        ? item.title
                        : negativePattern.test(item.value ?? '-00d')
                        ? `No ${item.title} Time`
                        : `${item.title} Time`
                      : item.title === 'Waiting Time'
                      ? `No ${item.title}`
                      : `No ${item.title} Time`
                  }
                >
                  <Flex align={'center'}>
                    <Box ml={index !== 0 ? 3 : 'auto'} mr={1}>
                      {!item.value ||
                      negativePattern.test(item.value ?? '-00d') ? (
                        <LinkBroken fill={'white'} />
                      ) : ['pr_cycle_time', 'wait_time'].includes(item.icon) ? (
                        <HourGlassIcon />
                      ) : item.icon === 'coding_time' ? (
                        <FileCodeIcon />
                      ) : item.icon === 'pickup_time' ? (
                        <StopWatchIcon />
                      ) : item.icon === 'merge_time' ? (
                        <GitMergeIcon />
                      ) : (
                        <></>
                      )}
                    </Box>

                    {index < 4 && (
                      <Text
                        color="text.secondary2"
                        fontFamily="heading"
                        fontSize="sm"
                        fontWeight="normal"
                        minW={
                          !negativePattern.test(item.value ?? '-00d')
                            ? 'max-content'
                            : 30
                        }
                        ml={item.value && index !== 0 ? 1 : 'auto'}
                      >
                        {negativePattern.test(item.value ?? '-00d')
                          ? ''
                          : item.value}
                      </Text>
                    )}
                  </Flex>
                </Tooltip>
              </Flex>

              {index < 3 &&
                (item.value ? (
                  <Box position="relative">
                    <Box className="dashed-line variant1" w={200} />
                    <Box position="absolute" left={195} top={'-11px'}>
                      <MdArrowRight size={24} color={'#8F8F91'} />
                    </Box>
                  </Box>
                ) : (
                  <Box position="relative">
                    <Box className="dashed-line variant1" w={240} />
                    <Box position="absolute" left={230} top={'-11px'}>
                      <MdArrowRight size={24} color={'#8F8F91'} />
                    </Box>
                  </Box>
                ))}
            </Fragment>
          );
        })}
      </Flex>
    </Box>
  );
};
